import React, { useState, useEffect } from 'react';
import Carousel from 'react-elastic-carousel';
import '../../stylesheet/datetime.css'; // Import the updated CSS file

export default function DateTimeCarousel({ setTobeDisplayed }) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [futureDates, setFutureDates] = useState([]);

  useEffect(() => {
    const getFutureDates = () => {
      const dates = [];
      for (let i = 0; i < 8; i++) {
        const futureDate = new Date(currentDate);
        futureDate.setDate(currentDate.getDate() + i);
        dates.push(futureDate);
      }
      setFutureDates(dates);
    };

    getFutureDates();
  }, [currentDate]);

  const formatDate = (date) => {
    const options = { weekday: 'short', month: 'short', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  };

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 4, itemsToScroll: 2 },
    { width: 768, itemsToShow: 3, itemsToScroll: 3 }, // Adjusted for smaller screens
    { width: 1200, itemsToShow: 5 },
  ];

  return (
    <div className='date-time-main'  style={{ marginLeft: '8rem', maxWidth: '45%' }}>
      <div className="datetime-carousel-container">
        <Carousel breakPoints={breakPoints}>
          {futureDates.map((date, index) => (
            <div key={index} className="datetime-carousel-item">
              <p
                className="datetime-timecard"
                onClick={() => setTobeDisplayed(formatDate(date))}
              >
                {formatDate(date).split(',')[0] + ' ' + formatDate(date).split(' ')[2] + ' ' + formatDate(date).split(' ')[1]}
              </p>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
}
